<template>
    <div class="fill-height background_image" style="width: 100%">
        <v-container class="login">
            <div class="login_card">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <img src="/img/bobbee_logo_3.png" height="100vh" />
                    </v-col>
                </v-row>
                <v-row v-if="user && user.id" class="align-center">
                    <v-col cols="12" class="align-center text-center">
                        <h1>{{ user.firstname + " " + user.lastname }}</h1>
                        <h3>Votre email a bien été vérifiée</h3>
                        <v-btn-primary
                            rounded
                            class="mt-4"
                            width="80%"
                            elevation="0"
                            @click="end"
                            size="small"
                        >
                            Continuer
                        </v-btn-primary>
                    </v-col>
                </v-row>
                <v-row v-else-if="!loading" class="text-center">
                    <v-col cols="12">
                        <p>Le lien de vérification a expiré</p>
                        <router-link to="/">Retourner à la page de connexion</router-link>
                    </v-col>
                </v-row>
                <v-row v-else class="text-center">
                    <v-col cols="12">
                        <v-progress-circular indeterminate color="primary" />
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../../../types";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class EmailVerification extends Vue {
    loading = true;

    user: User = null;

    get token() {
        return this.$route.params.token;
    }

    async beforeMount() {
        try {
            const mutation = gql(
                String.raw`mutation AssociatedUser($token: String!) {
                    updateUser(
                        where: {
                            emailVerificationToken: $token
                        },
                        data: {
                            emailVerified: true
                            emailVerificationToken: null
                        }
                    ) {
                        id email firstname lastname
                    }
                }`,
            );
            const result = await this.$apollo.mutate({
                mutation: mutation,
                variables: {
                    token: this.token,
                },
            });
            if (result && result.data && result.data.updateUser) {
                this.user = result.data.updateUser;
            }
            this.loading = false;
        } catch (e) {
            this.loading = false;
            console.error(e);
            debugger;
        }
    }

    end() {
        this.$router.push({ name: "home" });
    }
}

export default toNative(EmailVerification);
</script>
<style scoped>
.background_image {
    background-color: #f9b12a !important;
}
</style>
